import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { openPrimaryDownload } from "../../lib/downloads";

const DialogUpdate = ({openDialog,setOpenDialog,title,message}) => {
    return(
        <Dialog open={openDialog} onClose={()=>{setOpenDialog(false)}}>
            
            <DialogTitle>
                {title}
            </DialogTitle>
            
            <DialogContent>
            
                <DialogContentText>
                    {message}
                </DialogContentText>

                <DialogActions>
                    <Button variant="outlined" 
                        onClick={
                            ()=>{
                                    setOpenDialog(false);
                                    openPrimaryDownload();
                                }
                            }>
                        Download
                    </Button>
                </DialogActions>

            </DialogContent>
        </Dialog>
    );
}

export default DialogUpdate;
